import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { IRpaConnectUIPathState } from 'app/rpa-bots/core/IRpaBots';

const uipathSelector = (state: IAppState) => state.rpaState.uiPathConnectors;

export const getUIPathConnList = createSelector(
    uipathSelector,
    (state: IRpaConnectUIPathState) => state.connectors
);

export const getIsLoadingList = createSelector(
    uipathSelector,
    (state: IRpaConnectUIPathState) => state.isLoadingList
);

export const getIsLoadingDetail = createSelector(
    uipathSelector,
    (state: IRpaConnectUIPathState) => state.isLoadingDetail
);

export const getUIPathCurrentConnector = createSelector(
    uipathSelector,
    (state: IRpaConnectUIPathState) => state.currentConnector
);
